<edit-dialog (action)="signalAction($event)" [title]="title" class="flex flex-col">
  <ng-container edit-body>
    <div id="_SUBTITLE_" class="font-bold text-black flex justify-center">
      <div class="flex items-center">
        <div class="p-2">{{ this.ship.shipName }}</div>
        <div class="p-2"></div>
      </div>
    </div>
    <div class="modal-center flex flex-col ism-black">
      <gray-label-wrapper [fieldLabel]="'Star System'" [fieldName]="'ssid'" class="w-full text-black flex items-center">
        <select class="mx-4 px-4 w-28 form-select ism-black" [(ngModel)]="ssid" (change)="setHexes(ssid())">
          @for (starSystem of starSystems() | orderBy: "number"; track starSystem._id) {
            <option [ngValue]="starSystem._id">{{ starSystem.number }}</option>
          }
        </select>
        <div>{{ hexes?.length }} Terminals</div>
      </gray-label-wrapper>

      <gray-label-wrapper [fieldLabel]="'Strategic Hex'" [fieldName]="'hex'" class="w-full text-black flex items-center">
        <select class="mx-4 px-4 w-28 form-select ism-black" [(ngModel)]="hex" (change)="setFleets(hex)">
          @for (hex of hexes; track hex) {
            <option [ngValue]="hex">{{ hex }}</option>
          }
        </select>
        <div>{{ fleets?.length || 0 }} Fleets</div>
      </gray-label-wrapper>

      <gray-label-wrapper [fieldLabel]="'Fleet'" [fieldName]="'fleet'" class="w-full text-black flex items-center">
        @let none = NONE;
        <select class="mx-4 px-4 w-80 form-select ism-black" [(ngModel)]="fleetId">
          <option [ngValue]="none">New Fleet</option>
          @for (fleet of fleets; track fleet._id) {
            <option [ngValue]="fleet._id">{{ fleet.fleetName }}</option>
          }
        </select>
      </gray-label-wrapper>

      <gray-label-wrapper [fieldLabel]="'Fleet Name'" [fieldName]="'fleetName'" class="w-full text-black flex items-center">
        @if (fleetId() == "none") {
          <input class="mx-4 px-4 w-80 form-input ism-black" placeholder="{{ fleetNamePlaceHolder }}" [(ngModel)]="fleetName" />
        }
        <!-- -->
        @else {
          <div class="mx-4 px-4">^^^^</div>
        }
      </gray-label-wrapper>

      @if (action === "buy") {
        <gray-label-wrapper [fieldLabel]="'Purchase Price'" [fieldName]="'price'" class="w-full text-black flex items-center">
          <div class="mx-4">{{ shipClass.buildCost | number: "1.1-1" }} MC</div>
        </gray-label-wrapper>
        <gray-label-wrapper [fieldLabel]="'Monthly Maintenance'" [fieldName]="'maint'" class="w-full text-black flex items-center">
          <div class="mx-4">{{ shipClass.maintenanceCost | number: "1.1-1" }} MC</div>
        </gray-label-wrapper>
      }
    </div>
  </ng-container>
</edit-dialog>
